var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _c("e-button", {
            attrs: {
              busy: _vm.loadingRequisitions,
              text: _vm.$t("Associar Requisição de Compra"),
              variant: "primary",
              icon: "plus",
            },
            on: { click: _vm.openSidebar },
          }),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "bordered",
        attrs: {
          "show-empty": "",
          responsive: "",
          striped: "",
          "empty-text": _vm.$t("Nenhuma requisição de compra associada"),
          fields: _vm.fields,
          items: _vm.purchaseOrder.purchaseRequisitions,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(purchaseRequisitionId)",
            fn: function (row) {
              return [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "purchase-requisition-maintain",
                        params: { id: row.item.purchaseRequisitionId },
                      },
                      target: "_blank",
                    },
                  },
                  [_vm._v(" " + _vm._s(row.item.purchaseRequisitionId) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(status)",
            fn: function (row) {
              return [
                row.item.status
                  ? _c("e-status-badge", {
                      attrs: {
                        status: row.item.status,
                        options: _vm.mxPurchaseRequisitionStatusOptions(),
                      },
                    })
                  : _c("small", { staticClass: "text-muted" }, [_vm._v("-")]),
              ]
            },
          },
          {
            key: "cell(productsDisplay)",
            fn: function (row) {
              return [
                row.item.commonItems && row.item.commonItems.length > 0
                  ? _c("div", [
                      _c(
                        "small",
                        _vm._l(row.item.commonItems, function (item, idx) {
                          return _c("div", { key: idx }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatRequisitionItem(item)) +
                                " "
                            ),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("Nenhum produto em comum"))),
                    ]),
              ]
            },
          },
          {
            key: "cell(supplierOrders)",
            fn: function (row) {
              return [
                row.item.supplierOrders && row.item.supplierOrders.length > 0
                  ? _c("div", [
                      _c(
                        "small",
                        _vm._l(row.item.supplierOrders, function (order, idx) {
                          return _c("div", { key: idx }, [
                            _vm._v(
                              " " + _vm._s(_vm.formatSupplierOrder(order)) + " "
                            ),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("Nenhum pedido ao fornecedor"))),
                    ]),
              ]
            },
          },
          {
            key: "cell(action)",
            fn: function (row) {
              return [
                _c("e-grid-actions", {
                  attrs: { "show-update": false, "show-delete": true },
                  on: {
                    delete: function ($event) {
                      return _vm.onRemoveRequisition(row.index)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("e-sidebar", {
        attrs: {
          id: "sidebar-associate-requisitions",
          title: _vm.$t("Requisições de Compra Disponíveis"),
          show: _vm.showSidebar,
          fetching: _vm.loadingRequisitions,
          width: "1100px",
          "confirm-button-text": _vm.$t("Associar"),
        },
        on: { save: _vm.onAssociateRequisitions, hidden: _vm.onSidebarHidden },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _vm.searchResults.length === 0
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "Não existe nenhuma requisição de compra que tenha algum produto do pedido que ainda não foi finalizada"
                            )
                          ) +
                          " "
                      ),
                    ])
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-end align-items-center mb-1",
                        },
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "px-1 py-50",
                              attrs: {
                                variant:
                                  _vm.selectedRequisitions.length > 0
                                    ? "primary"
                                    : "secondary",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.selectionSummary) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c("b-table", {
                        ref: "availableRequisitionsTable",
                        staticClass: "bordered selectable-requisitions",
                        attrs: {
                          "show-empty": "",
                          responsive: "",
                          striped: "",
                          hover: "",
                          "empty-text": _vm.$t("Nenhuma requisição encontrada"),
                          fields: _vm.searchFields,
                          items: _vm.searchResults,
                          selectable: "",
                          "select-mode": "multi",
                          "selected-variant": "primary",
                        },
                        on: { "row-selected": _vm.onRowSelected },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(status)",
                            fn: function (row) {
                              return [
                                _c("e-status-badge", {
                                  attrs: {
                                    status: row.item.status,
                                    options:
                                      _vm.mxPurchaseRequisitionStatusOptions(),
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(matchedItems)",
                            fn: function (row) {
                              return [
                                row.item.matchedItems.length > 0
                                  ? _c("div", [
                                      _c(
                                        "small",
                                        _vm._l(
                                          row.item.matchedItems,
                                          function (item, idx) {
                                            return _c("div", { key: idx }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatRequisitionItem(
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Nenhum produto em comum")
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                          {
                            key: "cell(supplierOrders)",
                            fn: function (row) {
                              return [
                                row.item.supplierOrders &&
                                row.item.supplierOrders.length > 0
                                  ? _c("div", [
                                      _c(
                                        "small",
                                        _vm._l(
                                          row.item.supplierOrders,
                                          function (order, idx) {
                                            return _c("div", { key: idx }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatSupplierOrder(
                                                      order
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Nenhum pedido ao fornecedor")
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }